import { FileText, Settings } from 'lucide-react';
import { useI18n } from '@/contexts/i18n-hook';

interface NavegacaoEdicaoMaquinaProps {
  etapaAtiva: 'dados' | 'partes';
  onEtapaChange: (etapa: 'dados' | 'partes') => void;
}

export function NavegacaoEdicaoMaquina({
  etapaAtiva,
  onEtapaChange,
}: NavegacaoEdicaoMaquinaProps) {
  const { t } = useI18n();

  const etapas = [
    {
      id: 'dados' as const,
      label: t('apreciacaoTabelas.navegacao.dadosMaquina'),
      icon: Settings,
    },
    {
      id: 'partes' as const,
      label: t('apreciacaoTabelas.navegacao.partesMaquina'),
      icon: FileText,
    },
  ];

  return (
    <div className="bg-white dark:bg-schmersal-gray-darker border-b border-gray-200 dark:border-schmersal-gray-dark">
      <nav className="flex space-x-1 px-4">
        {etapas.map((etapa) => {
          const Icon = etapa.icon;
          const isActive = etapaAtiva === etapa.id;
          
          return (
            <button
              key={etapa.id}
              type="button"
              onClick={() => onEtapaChange(etapa.id)}
              className={`flex items-center gap-2 px-4 py-3 border-b-2 transition-colors ${
                isActive
                  ? 'border-blue-500 dark:border-schmersal-blue text-blue-600 dark:text-schmersal-blue bg-blue-50 dark:bg-schmersal-blue/10'
                  : 'border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:border-gray-300 dark:hover:border-schmersal-gray-dark'
              }`}
            >
              <Icon
                className={`h-5 w-5 ${
                  isActive
                    ? 'text-blue-500 dark:text-schmersal-blue'
                    : 'text-gray-400 dark:text-gray-500'
                }`}
              />
              <span className="font-medium text-sm">{etapa.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}

